// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"om_a bht_a bht_x","FilterForm__vgroup":"om_b bht_sv"};